import { Grid, Box, Skeleton } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const dealer = {
  register:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2Fregisrter.webp?alt=media&token=3b127fe8-efee-4eed-804c-3d99e83a0d09",
  dealer:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2Fdealer.webp?alt=media&token=ff1b23bf-3a11-4865-a049-5df56f1f5e8e",
};

export default function InterestDealer({ Intrestdata, onScrollToInterest}) {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <Grid style={{ height:"45vh",display:"flex", justifyContent:"center",alignItems:"center", borderBottom :"1px solid #000", }}>
      {/* Registration & Dealer Section */}
      <Grid style={{width:"90%",height:"45vh"}}>
        <Grid container >
          {/* Register Image */}
          <Grid
            style={{borderRight:"1px solid #000",
              width:"50%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center"}}
            
            
          >
            <Box
              component="img"
              loading="eager"
              decoding="async"
              src={dealer.register}
              alt="Register"
              onClick={onScrollToInterest}
              sx={{
                width: "175px",
                height: "230px",
                objectFit: "contain",
                maxWidth: "100%",
                cursor: "pointer",
              }}
            />
          </Grid>

          {/* Dealer Image */}
          <Grid
            style={{width:"50%",
              height:"45vh",
              display:"flex",
            justifyContent:"center",
            alignItems:"center"}}
            
          >
            {/* <Link to={"/"}> */}
            {!isLoaded && (
              <Skeleton
                animation="wave"
                variant="rectangular"
                sx={{
                  width: "175px",
                  height: "230px",
                  objectFit: "contain",
                  maxWidth: "100%",
                }}
              />
            )}
            <Box
              component="img"
              loading="eager"
              decoding="async"
              onLoad={() => setIsLoaded(true)}
              src={dealer.dealer}
              alt="Dealer"
              sx={{
                width: "175px",
                height: "230px",
                objectFit: "contain",
                maxWidth: "100%",
                cursor: "pointer",
              }}
              onClick={() => {
                const link = document.createElement("a");
                link.href = Intrestdata;
                link.target = "_blank";
                link.setAttribute("download", Intrestdata.split("/").pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            />

            {/* </Link> */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
